export const TOTAIS_DASHBOARD_PLUVIOMETRO = 'TOTAIS_DASHBOARD_PLUVIOMETRO'

export const TOTAIS_DASHBOARD_PLUVIOMETRO_PENDING = 'TOTAIS_DASHBOARD_PLUVIOMETRO_PENDING'
export const TOTAIS_DASHBOARD_PLUVIOMETRO_SUCCESS = 'TOTAIS_DASHBOARD_PLUVIOMETRO_SUCCESS'
export const TOTAIS_DASHBOARD_PLUVIOMETRO_FAILURE = 'TOTAIS_DASHBOARD_PLUVIOMETRO_FAILURE'
